import { ref } from 'vue'

export class AppVisibility {
  #browserPrefixes = ['moz', 'ms', 'o', 'webkit']
  #hiddenPropertyName

  constructor () {
    this.isVisible = ref(true)
    this.#hiddenPropertyName = this.getHiddenPropertyName(this.browserPrefix)
    this.visibilityEventName = (this.browserPrefix || '') + 'visibilitychange'
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this)
    this.onFocus = this.onFocus.bind(this)
    this.onBlur = this.onBlur.bind(this)
  }

  get browserPrefix () {
    const browserPrefixes = this.#browserPrefixes
    for (var i = 0; i < browserPrefixes.length; i++) {
      if (this.getHiddenPropertyName(browserPrefixes[i]) in document) {
        // return vendor prefix
        return browserPrefixes[i]
      }
    }

    // no vendor prefix needed
    return null
  }

  getHiddenPropertyName (prefix) {
    return (prefix ? prefix + 'Hidden' : 'hidden')
  }

  onVisible () {
    // prevent double execution
    if (this.isVisible.value) {
      return
    }

    // change flag value
    this.isVisible.value = true
  }

  onHidden () {
    // prevent double execution
    if (!this.isVisible.value) {
      return
    }

    // change flag value
    this.isVisible.value = false
  }

  handleVisibilityChange (forcedFlag) {
    // forcedFlag is a boolean when this event handler is triggered by a
    // focus or blur eventotherwise it's an Event object
    if (typeof forcedFlag === 'boolean') {
      if (forcedFlag) {
        return this.onVisible()
      }

      return this.onHidden()
    }

    if (document[this.#hiddenPropertyName]) {
      return this.onHidden()
    }

    return this.onVisible()
  }

  onFocus () {
    this.handleVisibilityChange(true)
  }

  onBlur () {
    this.handleVisibilityChange(false)
  }

  init () {
    document.addEventListener(this.visibilityEventName, this.handleVisibilityChange, false)

    // extra event listeners for better behaviour
    document.addEventListener('focus', this.onFocus, false)
    document.addEventListener('blur', this.onBlur, false)
    window.addEventListener('focus', this.onFocus, false)
    window.addEventListener('blur', this.onBlur, false)
  }

  destroy () {
    document.removeEventListener(this.visibilityEventName, this.handleVisibilityChange, false)

    // extra event listeners for better behaviour
    document.removeEventListener('focus', this.onFocus, false)
    document.removeEventListener('blur', this.onBlur, false)
    window.removeEventListener('focus', this.onFocus, false)
    window.removeEventListener('blur', this.onBlur, false)
  }
}
